import { render, staticRenderFns } from "./ni-icon-arrow.vue?vue&type=template&id=3d87f546"
import script from "./ni-icon-arrow.vue?vue&type=script&lang=js"
export * from "./ni-icon-arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports